var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPauseOutlinebutton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 226.01 226.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke-width:0px;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:4.48px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 113,
    cy: 113,
    r: 110.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m94,152.76h0c-5.58,0-10.11-4.53-10.11-10.11v-50.71c0-5.58,4.53-10.11,10.11-10.11s10.11,4.53,10.11,10.11v50.71c0,5.58-4.53,10.11-10.11,10.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m135.08,152.76h0c-5.58,0-10.11-4.53-10.11-10.11v-50.71c0-5.58,4.53-10.11,10.11-10.11s10.11,4.53,10.11,10.11v50.71c0,5.58-4.53,10.11-10.11,10.11"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseOutlinebutton);
export default __webpack_public_path__ + "static/media/PauseOutlinebutton.67f22e0181299f4a82eb1388744ee892.svg";
export { ForwardRef as ReactComponent };